"use strict";
const isBlank = (value) => value === null || typeof value === "undefined";
export default function(model, mailbox, path) {
  const value = model.getIn(path);
  return {
    value: isBlank(value) ? "" : value,
    requestChange: function(val) {
      if (val === "") {
        return mailbox.sendPayload([path, null]);
      }
      return mailbox.sendPayload([path, val]);
    }
  };
}
